<template>
  <div class="flex flex-row flex-nowrap border rounded-md gap-3 p-2 pb-5 justify-between cursor-pointer">
    <div class="basis flex flex-col gap-0.5 p-1 flex-1 min-w-0">
      <div class="" v-if="foodIcon">
        <V3ImageComponent :src="foodIcon" class="h-6 w-6" />
      </div>
      <p class="text-sm md:text-md line-clamp-2 break-words font-bold">{{ product.name }}</p>
      <div class="flex flex-col gap-0.5">
        <div class="inline-flex items-center flex-wrap md:flex-nowrap gap-1" v-if="isRangeGiven">
          <span class="text-sm md:text-md font-semibold">&#8377; {{ parseFloat((product.price_range.min_price).toFixed(2)) }} <!-- - {{ parseFloat((product.price_range.max_price).toFixed(2)) }} --> </span>
          <span class="px-1 text-sm md:text-md text-gray-500 line-through" v-if="product.discount > 0">&#8377; {{ parseFloat((product.price_range.max_price).toFixed(2)) }}</span>
          <span class="px-1 text-xs md:text-sm text-info-600" v-if="product.discount > 0 && !product.is_customizable">{{ Math.floor(product.discount) }}% off</span> 
        </div>
        <div class="inline-flex items-center flex-wrap md:flex-nowrap gap-1" v-else>
          <span class="text-sm md:text:md font-semibold">&#8377; {{ parseFloat((product.price).toFixed(2)) }}</span>
          <span class="px-1 text-sm md:text-md text-gray-500 line-through" v-if="product.discount > 0">&#8377; {{ parseFloat((product.max_price).toFixed(2)) }}</span>
          <span class="px-1 text-xs md:text-sm text-info-600" v-if="product.discount > 0  && !product.is_customizable">{{ Math.floor(product.discount) }}% off</span> 
        </div>
      </div>
      <!-- <p class="text-xs line-clamp-2 break-words text-gray-500" v-if="product.has_variant">{{ '* Variants Avaliable' }}</p> -->
     <!-- <span class="px-1 text-sm text-success-600 font-semibold">{{ 10 }}% off</span> -->

      <!-- <p class="text-sm text-gray-500 line-clamp-2 break-all" v-html="product.detail.summary"></p> -->
      <!-- <div class="flex flex-col gap-1 py-1" v-if="product.discount > 0">
        <UDivider/>
        <span class="px-1 text-sm text-info-600">{{ Math.floor(product.discount) }}% off</span> 
      </div> -->
    </div>
    <div class="basis flex-shrink-0 relative pb-4 w-24">
      <div class="flex justify-center w-24 h-24 border rounded-md relative">
        <NuxtImg :src="thumbnail" class="h-[75%] rounded-md object-contain py-1" @error="setDefaultImage" v-if="thumbnail" :alt="product.name" :title="product.name"/>
      </div>
      <div class="absolute left-0 right-0 mx-auto flex justify-center" :class="[product.is_customizable ? 'top-[80px]' : 'bottom-1']">
        <UButton disabled variant="solid" label="Out of stock" class="text-nowrap w-24" size="xs" v-if="!product.is_stock_available"/>
        <div class="w-20" v-else>
          <V3CartButtonComponent size="xs" :product="product" label="Add" class="w-20" :customize="product.is_customizable" :variants="product.has_variant"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
const props = defineProps(['product']);
const runtimeConfig = useRuntimeConfig();

const thumbnail = ref('');
const foodIcon = useFoodIcon(props.product.food_type);
const isRangeGiven = computed(() => props.product.is_customizable && props.product.price_range.min_price !== props.product.price_range.max_price);


const setDefaultImage = (event) => {
  event.imageSrc = runtimeConfig.public.defaultProductImage;
}

onMounted(async () => {
  thumbnail.value = await useValidateThumbnailBuilder(props.product.images);
});

const formatPrice = (value) => {
  return Number.isInteger(value) ? value.toString() : value.toFixed(2)
}
</script>
